import React, { useState, useRef } from "react";
import { Formik, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signup } from "../store/api/auth";
import upload from "../assets/images/upload.png";
import http from "../services/http";

import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import * as Yup from "yup";
import { SpinnerCircular } from "spinners-react";

const SignUpScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputFileRefs = {
    headshot: useRef(null),
    cv: useRef(null),
    licenseFront: useRef(null),
    licenseBack: useRef(null),
  };

  const [error, setError] = useState("");
  // const [value, setValue] = useState();
  const [uploadSpin, setUploadSpin] = useState(false);
  const [headShotphoto, setHeadShotPhoto] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null); // State for storing PDF URL
  const [pictures, setPictures] = useState({
    headshot: { url: upload, original: null },
    cv: { url: upload, original: null },
    licenseFront: { url: upload, original: null },
    licenseBack: { url: upload, original: null },
  });
  const [isPicUpload, setPicUpload] = useState({
    headshot: false,
    cv: false,
    licenseFront: false,
    licenseBack: false,
  })


  const initialValues = {
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    password: "",
    confirmpassword: "",
  };
  const validationSchema = Yup.object({
    firstname: Yup.string().required("First Name is required").label("firstName"),
    lastname: Yup.string().required("Last Name is required").label("lastName"),
    phone: Yup.string()
      .required("Phone is Required"),
      // .matches(
      //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      //   "Phone number is not valid"
      // ),
    email: Yup.string().required("Email is required").email().label("Email"),
    password: Yup.string()
      .required("Password is required")
      .label("password")
      .min(6, "Password is too short - should be 6 chars minimum.")
      .matches(/(?=.*[0-9])/, "Password must contain a number."),
    confirmpassword: Yup.string().required("Confirm Password is required").when("password", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("password")],
        "Both password need to be the same"
      ),
    }),
  });
  const onSubmit = (values) => {
    if (!Object.values(isPicUpload).every(Boolean)) {
      setError("Please upload all documents.");
      return;
    }
    setUploadSpin(true);


    const formData = new FormData();
    formData.append("firstname", values.firstname);
    formData.append("lastname", values.lastname);
    formData.append("phone", `+1${values.phone}`);
    formData.append("email", values.email);
    formData.append("password", values.password);
    
    // Append files to the FormData
    formData.append("headshot", pictures.headshot.original);
    formData.append("cv", pictures.cv.original);
    formData.append("driverLicenseFrontSide", pictures.licenseFront.original);
    formData.append("driverLicenseBackSide", pictures.licenseBack.original);

    // console.log("formData",formData);

    http
      .post(`public/analyst`, formData)
      .then((res) => {
        setUploadSpin(false);
        showToast("success", "You've registered successfully.A verification code has been sent to your email and phone");
        localStorage.setItem("signupUserDetails", JSON.stringify({ id:res.data.data.id,email:res.data.data.email, phone:res.data.data.phone }));
        setTimeout(() => {
          navigate("/email-phone-verification");
        }, 5000);


      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });

    // dispatch(
    //   signup({
    //     body: {
    //       firstname: values.firstname,
    //       lastname: values.lastname,
    //       phone: values.phone,
    //       email: values.email,
    //       password: values.password,
    //     },

    //     onSuccess: (res) => {
    //       setUploadSpin(false);

    //       navigate("/");
    //     },
    //     onError: (error) => {
    //       setUploadSpin(false);

    //       if (error.response) {
    //         if (error.response.data.errors) {
    //           for (let key in error.response.data.errors) {
    //             setError(error.response.data.errors[key]);
    //           }
    //         } else if (error.response.data.message) {
    //           setError(error.response.data.message);
    //         }
    //       }
    //     },
    //   })
    // );
  };

  const validateFile = (file, type) => {
    const allowedTypes = type === "cv" ? ["application/pdf"] : ["image/jpeg", "image/png"];
    const maxSize = 2 * 1024 * 1024; // 2 MB
    return file && (allowedTypes.includes(file.type) && file.size <= maxSize);
  };

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (file && validateFile(file, type)) {
      const pictureToShow = URL.createObjectURL(file);

      setPictures((prev) => ({
        ...prev,
        [type]: { url: pictureToShow, original: file }, // Save both URL and original file
      }));
      setPicUpload((prev) => ({ ...prev, [type]: true }));

      // Set PDF URL if CV is uploaded
      if (type === "cv") {
        setPdfUrl(pictureToShow);
      }
    } else {
      if(file != undefined){

        setError(`Invalid file for ${type}. Allowed types: ${type === "cv" ? "PDF" : "JPEG, PNG"}. Max size: 2MB.`);
      }
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <section className="login_wraper">
          <div className="login_inner">
            <div className="login_logo mb_40">
              {" "}
              <img src="assets/images/logo.png" alt="" />
            </div>
            <h1 className="mb_30 main_title">Register Now </h1>
            <p className="mb_40 them_para">
              Please enter valid email Id and a strong password to procced with
              the login process
            </p>
            <form>
              <div className="top_fild">
                <div className="form-group   w-49">
                  <input
                    name="firstname"
                    className="form-control"
                    onChange={handleChange("firstname")}
                    onBlur={handleBlur("firstname")}
                    value={values.firstname}
                    placeholder="First Name"
                  />{" "}
                  <ErrorMessage component="div" className="text-danger" name="firstname" />
                </div>


                <div className="form-group   w-49">
                  <input
                    name="lastname"
                    className="custom_input form-control w-100"
                    onChange={handleChange("lastname")}
                    onBlur={handleBlur("lastname")}
                    value={values.lastname}
                    placeholder="Last Name"
                  />{" "}
                  <ErrorMessage component="div" className="text-danger" name="lastname" />
                </div>

              </div>
              {/* <Input
                international
                country="US"
                value={value}
                onChange={setValue}
                className="custom_input form-control  w-100"
              /> */}

              <div className="top_fild">

                <div className="form-group   w-49">

                  <input
                    type="text"
                    name=""
                    className="custom_input form-control  w-100"
                    onChange={handleChange("phone")}
                    onBlur={handleBlur("phone")}
                    value={values.phone}
                    placeholder="Phone Number"
                  />{" "}
                  <ErrorMessage component="div" className="text-danger" name="phone" />
                </div>

                <div className="form-group  w-49">
                  <input
                    type="email"
                    name=""
                    className="custom_input form-control  w-100"
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    value={values.email}
                    placeholder="Email"
                  />{" "}
                  <ErrorMessage component="div" className="text-danger" name="email" />
                </div>

              </div>

              <div className="top_fild">
                <div className="form-group  w-49">
                  <input
                    type="password"
                    name=""
                    onChange={handleChange("password")}
                    onBlur={handleBlur("password")}
                    value={values.password}
                    className="custom_input form-control  w-100"
                    placeholder="Password"
                  />
                  <ErrorMessage component="div" className="text-danger" name="password" />
                  {/*   <div className="img_icon">
                    {<a href="">
                      <img src="assets/images/visibility.png" alt="" />{" "}
                    </a>}
                  </div> */}
                </div>
                <div className="form-group  w-49">
                  <input
                    type="password"
                    name=""
                    onChange={handleChange("confirmpassword")}
                    onBlur={handleBlur("confirmpassword")}
                    value={values.confirmpassword}
                    className="custom_input form-control  w-100"
                    placeholder="Confirm Password"
                  />
                  <ErrorMessage component="div" className="text-danger" name="confirmpassword" />
                  {/* <div className="img_icon">
                    <a href="">
                      <img src="assets/images/visibility.png" alt="" />{" "}
                    </a>
                  </div> */}
                </div>
              </div>

              <div className="top_field">
                <div className="form-group d-flex justify-content-between w-100">
                  <div className="w-49">
                  <label htmlFor="headshot" style={{ display: "block", marginBottom: 5 }}>Upload Headshot</label>
                  <input
                      type="file"
                      ref={inputFileRefs.headshot}
                      onChange={(e) => handleFileChange(e, "headshot")}
                      style={{ display: "none" }}
                    />
                    <img
                      alt="headshot"
                      src={pictures.headshot.url}
                      onClick={() => inputFileRefs.headshot.current.click()}
                      style={{ width: 150, height: 150, border: "1px solid gray", borderRadius: "50%" }}
                    />
                  </div>

                  <div className="w-49">
                   <label htmlFor="headshot" style={{ display: "block", marginBottom: 5 }}>Upload Cv</label>

                    <input
                      type="file"
                      ref={inputFileRefs.cv}
                      onChange={(e) => handleFileChange(e, "cv")}
                      style={{ display: "none" }}
                    />
                    {pdfUrl ? (
                      // <object
                      //   width="100%"
                      //   height="100%"
                      //   data={pdfUrl}
                      //   type="application/pdf"
                      // >
                      //   <p>Your browser does not support PDFs. <a href={pdfUrl}>Download the PDF</a>.</p>
                      // </object>
                      <div onClick={() => inputFileRefs.cv.current.click()} style={{ cursor: 'pointer' }}>
                      <object
                        width="100%"
                        height="100%"
                        data={pdfUrl}
                        type="application/pdf"
                        style={{ border: "1px solid gray", borderRadius: "5px" }}
                      >
                        <p>Your browser does not support PDFs. <a href={pdfUrl}>Download the PDF</a>.</p>
                      </object>
                      <p style={{ textAlign: 'center', marginTop: '5px',textDecoration:"underline",color:"#007bff" }}>Click to change PDF</p>
                    </div>
                    ) : (
                      <img
                        alt="CV"
                        src={pictures.cv.url}
                        onClick={() => inputFileRefs.cv.current.click()}
                        style={{ width: 150, height: 150 }}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="top_field mt-5">
                <div className="form-group d-flex justify-content-between w-100">
                  <div className="w-49">
                  <label htmlFor="headshot" style={{ display: "block", marginBottom: 5 }}>Frontside Driver Licence</label>
                    <input
                      type="file"
                      ref={inputFileRefs.licenseFront}
                      onChange={(e) => handleFileChange(e, "licenseFront")}
                      style={{ display: "none" }}
                    />
                    <img
                      alt="license front"
                      src={pictures.licenseFront.url}
                      onClick={() => inputFileRefs.licenseFront.current.click()}
                      style={{ width: 150, height: 150, border: "1px solid gray", borderRadius: "50%" }}
                    />
                  </div>

                  <div className="w-49">
                  <label htmlFor="headshot" style={{ display: "block", marginBottom: 5 }}>Backside Driver Licence</label>

                    <input
                      type="file"
                      ref={inputFileRefs.licenseBack}
                      onChange={(e) => handleFileChange(e, "licenseBack")}
                      style={{ display: "none" }}
                    />
                    <img
                      alt="license back"
                      src={pictures.licenseBack.url}
                      onClick={() => inputFileRefs.licenseBack.current.click()}
                      style={{ width: 150, height: 150, border: "1px solid gray", borderRadius: "50%" }}
                    />
                  </div>
                </div>
              </div>






            </form>
            <h5 style={{ color: "red" }}>{error}</h5>
            <div className="btn_wraper">
              <button
                type="button"
                className="them_btn mt_40 mb_30"
                onClick={handleSubmit}
              >
                {uploadSpin ? (
                  <SpinnerCircular className="button-spin" />
                ) : (
                  "Sign Up"
                )}
              </button>
            </div>{" "}
            {/*  <a href="" className="btn-link mt_40 d-block">
                Forgot Password?
              </a>{" "} */}
          </div>
          <ToastContainer />
        </section>
      )}
    </Formik>
  );
};

export default SignUpScreen;
